<div>
    <ng-select bindLabel="CPA_KEY" class="search" loadingText="{{ 'D41' | translate : locale }}"
        notFoundText="{{ 'D42' | translate : locale }}" placeholder="{{ 'D1' | translate : locale }}"
        (change)="onChange($event)" (search)="onSearch($event.term)" [items]="searchResults" [loading]="loading"
        [minTermLength]="3" [searchFn]="searchFn">
        <ng-template ng-option-tmp let-item="item">
            <strong>{{ item.CPA_KEY }}</strong>
            <br />
            <small>{{ item.ACCOUNT }}</small>
        </ng-template>
    </ng-select>
</div>